module.exports = __webpack_public_path__ + "static/media/Icons_user.4aab0231.svg";